import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  listMessageTemplates,
  ListMessageTemplatesParams,
  MessageTemplateListItem,
} from "#/services/messageTemplates";

export function useMessageTemplatesList(params: ListMessageTemplatesParams) {
  return useQuery<MessageTemplateListItem[]>({
    queryKey: qk.messageTemplates(params),
    queryFn: ({ signal }) => listMessageTemplates(params, { signal }),
    staleTime: 30_000,
  });
}

export default useMessageTemplatesList;
